import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://iqteqknfrbukggitwdna.supabase.co";
const supabaseAnonKey = "sb_publishable_vWmRp0dpHaq6nr8WLCYp2w_BuIXXDZi";

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey
);